/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import blue from '@material-ui/core/colors/blue';
import styled from 'styled-components';

import RenderPhoneField from '../../utils/renderFields/RenderPhoneField';
import RenderPinField from '../../utils/renderFields/RenderPinField';
import RenderSelectField from '../../utils/renderFields/RenderSelectField';

import callingCodes from '../../utils/callingCodes.json';
import submit from './submit';
import logo from '../../img/logo.svg';
import bars from '../../img/bars.svg';
import { createPhoneCode } from './signinActions';
import Terms from './Terms';

const PhoneNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ConfirmationCodeTitle = styled.p`
  text-align: center;
  margin-bottom: 0;
  margin-top: 30px;
  font-size: 1.2em;
  font-weight: 300;
`;

const ActionLink = styled.div`
  text-align: center;
  margin-top: 30px;
  color: ${blue[500]};
  cursor: pointer;
  outline: none;
`;

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(15),
    padding: '20px 40px 40px 40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  }
}));

/* eslint-disable import/no-mutable-exports */
let SignIn = ({
  handleSubmit,
  createPhoneCodeSuccess,
  dispatchCreatePhoneCode,
  phoneNumber,
  callingCode,
  loading,
  history
}) => {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper className={classes.paper}>
        <img
          src={logo}
          alt="Logo sympl"
          width="230"
          style={{ marginBottom: 20 }}
        />
        <form
          className={classes.form}
          onSubmit={handleSubmit(submit)}
          noValidate
        >
          <PhoneNumberContainer>
            <Field
              name="callingCode"
              datas={callingCodes}
              id="calling-code"
              component={RenderSelectField}
            />
            <Field
              name="phoneNumber"
              id="phone-field"
              label="Numéro de téléphone"
              component={RenderPhoneField}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ position: 'relative', right: 5 }}
                  >
                    {loading ? (
                      <img alt="loader" src={bars} width="20" />
                    ) : (
                      <div />
                    )}
                  </InputAdornment>
                )
              }}
              style={{ width: '70%' }}
              autoFocus
              autoComplete="tel"
            />
          </PhoneNumberContainer>
          {createPhoneCodeSuccess ? (
            <>
              <ConfirmationCodeTitle style={{ textAlign: 'center' }}>
                Code de confirmation
              </ConfirmationCodeTitle>
              <Field
                name="confirmationCode"
                id="confirmation-code"
                component={RenderPinField}
                autoFocus
                autoComplete="tel"
              />
              <ActionLink
                role="link"
                tabIndex="0"
                onClick={() => {
                  const currentPhoneNumber = parsePhoneNumberFromString(
                    `${callingCode}${phoneNumber}`
                  );
                  dispatchCreatePhoneCode(
                    currentPhoneNumber.formatInternational()
                  );
                }}
              >
                Renvoyer le code
              </ActionLink>
            </>
          ) : (
            ''
          )}
          <Terms />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {createPhoneCodeSuccess ? 'Se connecter' : 'Recevoir mon code'}
          </Button>
          <ActionLink
            role="link"
            tabIndex="0"
            onClick={() => {
              history.push('/signup');
            }}
          >
            Inscription
          </ActionLink>
          <Grid container>
            <Grid item xs />
            <Grid item />
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

const mapDispatchToProps = {
  dispatchCreatePhoneCode: phoneNumber => createPhoneCode(phoneNumber)
};

const selector = formValueSelector('loginForm');
const mapStateToProps = state => ({
  initialValues: {
    callingCode: '+33'
  },
  createPhoneCodeSuccess: state.signin.createPhoneCodeSuccess,
  loading: state.signin.loading,
  phoneNumber: selector(state, 'phoneNumber'),
  callingCode: selector(state, 'callingCode')
});

SignIn = reduxForm({
  form: 'loginForm'
})(SignIn);

SignIn.propTypes = {
  handleSubmit: PropTypes.func,
  phoneNumber: PropTypes.string,
  callingCode: PropTypes.string,
  dispatchCreatePhoneCode: PropTypes.func.isRequired,
  createPhoneCodeSuccess: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignIn));
